/**
 * The single React component that hosts Phaser. A ref'd container + a useEffect
 * that boots the game on mount and destroys it on unmount. It holds NO React
 * state, so it never re-renders while the game is playing — from React's side
 * it's an opaque box. All game↔UI traffic goes through the GameBus.
 */
import { useEffect, useRef } from 'react';
import type Phaser from 'phaser';
import { bootGame } from '../game/bootGame';
import type { GameBus } from '../game/events';

export function GameCanvas({
  bus,
  skinId,
  directRun = false,
}: {
  bus: GameBus;
  skinId: string;
  /** Boot straight into a run (MainScene) instead of the menu flow — used for restart. */
  directRun?: boolean;
}) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    let game: Phaser.Game | null = bootGame(el, bus, skinId, directRun);

    return () => {
      // true → also remove the <canvas> from the DOM.
      game?.destroy(true);
      game = null;
    };
  }, [bus, skinId, directRun]);

  return <div ref={containerRef} className="game-canvas" />;
}
